import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';

import PageWrapper from '../components/PageWrapper';
import ReadMore from '../components/ReadMore';
import innovationPath from '../../assets/images/innovationPath.png';
import BeyondPaperGraphics from './components/BeyondPaperGraphics';
import ScrollToTop from '../components/ScrollToTop';

const InnovationPage = (props) => {
  const { height, width, MAX_WIDTH, isMobile } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageWrapper height={height} showHeaderLogo isMobile={isMobile}>
      {/* <div className="backgroundRectangle" style={{
            position: 'absolute',
            height: 1200,
            width,
            zIndex: -1
          }} />
          <div className="backgroundArrow" style={{
        position: 'absolute',
        height: 3400,
        width,
        zIndex: -1
      }} /> */}
      <Row>
        <Col>
          <h2 style={{ marginTop: 120 }}>
            INNO{isMobile && "-"}{isMobile && <br />}VATION
          </h2>
          <p style={{ marginTop: 30 }}>
            Industry standards are at the heart of everything we do. We use CSIO Standards to develop innovative solutions – CSIOnet, eDocs and eSlips, just to name a few.
          </p>
          <p>
            Those same standards – like eDocs – support even more innovative solutions, like the ones you’ll read about in this section of the report. It’s a never-ending cycle of benefits and efficiencies – one that allows us to bring more solutions to CSIO members, in shorter timeframes.
          </p>
          <p>
            2020 was an unusual year. But the challenges kept feeding the innovation, as we found new ways to connect and keep moving forward.
          </p>
          <h3 style={{ marginTop: 60, textAlign: 'center' }} id="innotech-advisory-committee" tabIndex="-1">
            INNOVATION AND EMERGING TECHNOLOGY (INNOTECH) ADVISORY COMMITTEE
          </h3>
          <p style={{ marginTop: 30 }}>
            The Innovation and Emerging Technology (INNOTECH) Advisory Committee is the way CSIO delivers leading-edge technology solutions. The Committee, and its Working Groups, made tremendous progress this year in:
          </p>
          <ul>
            <li className="credibleLi">
              identifying three common industry pain points, and
            </li>
            <li className="credibleLi">
              quickly moving on to research and secure three digital solutions to digitize billing and claims notification, and standardize APIs, that will improve operational efficiency and the customer experience.
            </li>
          </ul>
          <img
            src={innovationPath}
            style={{
              width: '100%',
              height: 'auto',
              marginTop: 30,
              padding: 60
            }}
            aria-label="A timeline chart. August 2019, innotech launched. November 2019, first meeting held and mandate finalized to focus on common industry pain points. The following all occured in 2020. January, committee explores potential digital solutions to resolve identified pain points. February, committee approves further review of proposed solutions. March, working groups formed with subject matter experts to map use cases and quantify ROI for proposed solutions. April, claims and billing working group first sessions held. May, API working group first session held. June, claims and billing working groups completes proposal and define requirements. July, API working group determines the standard will leverage JSON and discusses specification. August, API working group outlines API data types, security documentation, and proof of concept approaches. Also in August, committee review business requirements and proposed solutions completed by the working groups and agrees on next steps. September, CSIOs board of directors approves committees proposed industry solutions. October, API security working group is launched to develop a framework for API central security model. November, API security working group identified key components for a standard security model to facilitate industry APIs. December, CSIOnet and eDoc standard are leveraged for the billing notification solution."
          />
          <div style={{
            display: 'flex',
            justifyContent: 'center'
          }}>
            <ReadMore asA title="Learn More" href="https://www.csio.com/membership/innotech-advisory-committee" target="_blank" rel="noreferrer" />
          </div>
          <p style={{
            marginTop: 30
          }}>
            CSIO acknowledges and thanks the members of the <a className="detailsLink" aria-label="Open pdf with advisory committee members in new tab" href="https://www.csio.com/membership/innotech-advisory-committee/committee-members" target="_blank" rel="noreferrer">INNOTECH Advisory Committee</a> and <a className="detailsLink" aria-label="Open pdf with working groups in new tab" href="https://www.csio.com/membership/innotech-advisory-committee/committee-members/working-group-participants" target="_blank" rel="noreferrer">INNOTECH Working Groups</a> for their ongoing contributions.
          </p>
          <h3
            id="my-proof-of-insurance"
            tabIndex="-1"
            style={{
              marginTop: 60, textAlign: 'center'
            }}>
            MY PROOF OF INSURANCE
          </h3>
          <p style={{ marginTop: 30 }}>
            The My Proof of Insurance (MPOI) solution allows insurance providers to send policy documents and eSlips to personal and commercial lines customers through secure email. Customers can easily receive and view their documents on any device, and eSlips can be stored in a smartphone’s mobile wallet.
          </p>
          <h4
            // className="carouselValueTitle"
            // style={{ marginTop: 30, textAlign: 'center', fontFamily: 'Montserrat Bold', fontSize: 20, color: '#004761' }}
            style={{paddingTop: 12}}
            >
            Beyond Paper…Beyond Expectations
            </h4>
          <p style={{ marginTop: 30 }}>
            2020’s need for more virtual, digital experiences accelerated the interest in the quick, secure and seamless solution that My Proof of Insurance (MPOI) provides. The results speak for the themselves.
          </p>
          <BeyondPaperGraphics />
          <p style={{ marginTop: 40 }}>
            Members were provided with a <a className="detailsLink" href="https://csio.com/press-release/economical-insurance-implements-csio%E2%80%99s-my-proof-insurance-digital-document-delivery#mpoi-insurer-video" target="_blank" rel="noreferrer">video</a> to help them understand and promote MPOI.
          </p>

          <div style={{ marginTop: 60, backgroundColor: '#F3F5ED', padding: 20 }}>
            <p className="detailsQuote">
              “We’re always cognizant of offering our customers and brokers a seamless and efficient approach to doing business with us. My Proof of Insurance met all of the requirements for our paperless strategy. It’s a multifunctional solution capable of sending not only eSlips, but any renewal document, new policy, endorsements, and even billing and claims statements; whatever we need to send to customers, we can do it using this solution. The ability to deliver a strong digital customer experience is expected from us, that’s why it was an easy ‘yes’ to this solution.”
            </p>
            <p>
            <span className="detailsAuthorText">CAM LOEPPKY</span>
              <span className="valueExecDetail">
                , The Wawanesa Mutual Insurance Company, Senior Vice President & Chief Information Officer
                </span>
            </p>
          </div>

          {/* <p className="detailsQuote" style={{ marginTop: 60 }}>
            “We’re always cognizant of offering our customers and brokers a seamless and efficient approach to doing business with us. My Proof of Insurance met all of the requirements for our paperless strategy. It’s a multifunctional solution capable of sending not only eSlips, but any renewal document, new policy, endorsements, and even billing and claims statements; whatever we need to send to customers, we can do it using this solution. The ability to deliver a strong digital customer experience is expected from us, that’s why it was an easy ‘yes’ to this solution.”
          </p>
          <div style={{
            padding: 10,
            backgroundColor: '#F3F5ED',
            marginTop: 30
          }}>
            <div className="detailsAuthorText">
              CAM LOEPPKY
            </div>
            <div className="valueExecDetail" style={{textAlign: 'left'}}>
              The Wawanesa Mutual Insurance Company Senior Vice President & Chief Information Officer
            </div>
          </div> */}
        </Col>
      </Row>
      <ScrollToTop height={height} width={width} maxWidth={MAX_WIDTH}/>
    </PageWrapper>
  )
}

export default InnovationPage;
